export default __webpack_public_path__ + "static/media/17.d7ab6584.png";